// let proxy_pre = '';
let proxy_pre = '/api';
let user_pre = '/user';
let remote_pre = '/remote';
let file_pre = '/file';

const user_login_path = proxy_pre + user_pre + '/login';
const user_register_path = proxy_pre + user_pre + '/register';
const user_logout_path = proxy_pre + user_pre + '/deregister';
const user_send_code_path = proxy_pre + user_pre + '/send_code';
const user_update_name_path = proxy_pre + user_pre + '/update_username';


const chunk_upload_path = proxy_pre + remote_pre + '/upload_chunk';
const cancel_upload_path = proxy_pre + remote_pre + '/cancel_upload';
const chunk_download_path = proxy_pre + remote_pre + '/download_chunk';
const cancel_download_path = proxy_pre + remote_pre + '/cancel_download';
const file_content_path = proxy_pre + remote_pre + '/get';
const file_save_path = proxy_pre + remote_pre + '/save';
const dir_compress_path = proxy_pre + remote_pre + '/compress';

const file_list_path = proxy_pre + file_pre + '/list';
const file_delete_path = proxy_pre + file_pre + '/delete';
const file_mkdir_path = proxy_pre + file_pre + '/mkdir';
const file_rename_path = proxy_pre + file_pre + '/rename';
const file_move_path = proxy_pre + file_pre + '/move';


export {
    proxy_pre,
    user_login_path,
    user_register_path,
    user_logout_path,
    user_send_code_path,
    user_update_name_path,

    chunk_upload_path,
    cancel_upload_path,
    chunk_download_path,
    cancel_download_path,
    file_content_path,
    file_save_path,
    dir_compress_path,

    file_list_path,
    file_delete_path,
    file_mkdir_path,
    file_rename_path,
    file_move_path
}